"use strict";
// We have the following vendor prefixing specifically for flexbox to prevent issues when hosted in ancient Tableau Desktop Qt Webkit
// We don't do prefixing generally mostly because we haven't had issues broadly enough to warrant a grander solution
// See TFSID 1030484
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flex = exports.FlexShrink0 = exports.FlexGrow1 = exports.FlexDirectionColumnReverse = exports.FlexDirectionColumn = exports.DisplayFlex = exports.DisplayInlineFlex = exports.JustifyContentCenter = exports.AlignItemsCenter = void 0;
exports.AlignItemsCenter = {
    '-webkit-align-items': 'center',
    alignItems: 'center',
};
exports.JustifyContentCenter = {
    '-webkit-justify-content': 'center',
    justifyContent: 'center',
};
exports.DisplayInlineFlex = {
    display: ['-webkit-inline-flex', 'inline-flex'],
};
exports.DisplayFlex = {
    display: ['-webkit-flex', 'flex'],
};
exports.FlexDirectionColumn = {
    '-webkit-flex-direction': 'column',
    flexDirection: 'column',
};
exports.FlexDirectionColumnReverse = {
    '-webkit-flex-direction': 'column-reverse',
    flexDirection: 'column-reverse',
};
exports.FlexGrow1 = {
    '-webkit-flex-grow': 1,
    flexGrow: 1,
};
exports.FlexShrink0 = {
    '-webkit-flex-shrink': 0,
    flexShrink: 0,
};
exports.Flex = function (value) { return ({
    '-webkit-flex': value,
    flex: value,
}); };
//# sourceMappingURL=Flexbox.js.map